// react
import { useContext } from 'react';

// context
import { ContextReimbursements } from '../../Project.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableReimbursements } from '../../../../tables/cards/TableReimbursements/TableReimbursements';

export const Reimbursements = () => {
	// context
	const {
		isLoadingReimbursements,
		paginationReimbursements,
		refetchReimbursements,
		reimbursements,
	} = useContext(ContextReimbursements);

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TableReimbursements
						isLoading={isLoadingReimbursements}
						pagination={paginationReimbursements}
						refetchTransactions={refetchReimbursements}
						transactions={reimbursements}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};
